import { Typography, useMediaQuery, useTheme } from '@material-ui/core'
import Banner from 'baby-ui/foundation/Banner/Banner'
import React from 'react'
import Link from 'baby-ui/foundation/Link/Link'
import FreeGiftModal from 'baby-ui/compounds/FreeGiftModal/FreeGiftModal'
import useStyles from './AnnouncementBannerWidget.styles'
import { AnnouncementBannerController } from './AnnouncementBannerController'
import { STARBURST_URL } from './AnnouncementBannerWidget.constants'

const AnnouncementBannerWidget = () => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const adornmentPosition = isMobile ? 'right' : 'left'
  const pathname = window?.location?.pathname || ''
  const bannerController = new AnnouncementBannerController(pathname)
  const [isFreeGiftModalOpen, setIsFreeGiftModalOpen] = React.useState(false)

  if (!bannerController.shouldDisplayBanner) {
    return null
  }

  const adornmentUrl = bannerController.shouldDisplayAdornment
    ? STARBURST_URL
    : undefined

  const desktopAdcopy = (
    <>
      <Typography component="span" style={{ fontSize: '1.8rem' }}>
        Get a <b>FREE</b> gift with your pump!
      </Typography>{' '}
      <Typography component="span" variant="body2">
        Order now and get a free set of breast milk storage bags.
      </Typography>
    </>
  )

  const mobileAdcopy = (
    <>
      <Typography component="span" style={{ fontSize: '1.6rem' }}>
        Order now and get a <b>FREE</b> set of breast milk storage bags!
      </Typography>
    </>
  )

  return (
    <>
      <FreeGiftModal
        open={isFreeGiftModalOpen}
        onClose={() => setIsFreeGiftModalOpen(false)}
      />

      <Banner
        adornmentAlt="Fre gift with your order"
        adornmentPosition={adornmentPosition}
        adornmentUrl={adornmentUrl}
        onAdornmentClick={() => {
          setIsFreeGiftModalOpen(true)
        }}
      >
        <Link
          className={classes.teaser}
          href="#free-gift-banner"
          onClick={(e) => {
            if (!bannerController.isHomePage) {
              e.preventDefault()
              setIsFreeGiftModalOpen(true)
            }
          }}
        >
          <span>{isMobile ? mobileAdcopy : desktopAdcopy}</span>
        </Link>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Link
          className={classes.moreDetails}
          color="inherit"
          href="#"
          variant="chevronIcon"
          onClick={(e) => {
            e.preventDefault()
            setIsFreeGiftModalOpen(true)
          }}
        >
          See details/terms
        </Link>
      </Banner>
    </>
  )
}

export default AnnouncementBannerWidget
